import { render, staticRenderFns } from "./DeliveryShowResultIssues.vue?vue&type=template&id=12dcbe27&scoped=true"
import script from "./DeliveryShowResultIssues.vue?vue&type=script&lang=ts"
export * from "./DeliveryShowResultIssues.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryShowResultIssues.vue?vue&type=style&index=0&id=12dcbe27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dcbe27",
  null
  
)

export default component.exports